/* eslint-disable @typescript-eslint/naming-convention */
export enum Language {
    None,
    Persian,
    English,
}
